<template lang="html">
    <div class="makeComplaints" ref="makeComplaints">
      <div class="header">
        <!-- <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/makeComplaints.svg"/> -->
        <img @click="goCreate" src="https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E6%98%9F%E8%A8%80%E6%98%9F%E8%AF%AD%E5%8F%82%E4%B8%8E.png"/>
        <!-- <div class="button">
          <button @click="goCreate">戳我吐槽</button>
        </div> -->
        </div>
        <div class="content" :style="{'padding-bottom': isAndroid ? 0 : '100px' }">
          <DynamicItem @click="goDetails()" @deleteMessage="deleteMessage" @updateItem="(reload) => updateItem(item, reload)" v-for="item of list" :key="item.id" v-bind="item" />
        </div>
        <Loading :loading="loading"/>
        <Suspension v-if="platform !== 'notInDingTalk'" @share="getShareContent"/>
        <Suspension bottom="36px" desc="回首页" img="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home.svg" @share="goHome"/>
    </div>
</template>
<script>
import { isAndroid } from '../../../utils/utils'
import DynamicItem from './Item'
import { get } from '../../../utils/request'
import { set, remove, get as getUser } from '../../../utils/token'
import Loading from '../../../components/Loading'
import DDMixis from '../../../minixs/ddMixis'
import { goHomePath } from '../../../utils/power'
export default {
  components: {
    DynamicItem,
    Loading
  },
  mixins: [DDMixis],
  data () {
    return {
      isAndroid: isAndroid(),
      safeHeight: 0,
      list: [],
      loading: false,
      page: 1,
      size: 10,
      count: 0
    }
  },
  async mounted () {
    this.getMakeComplaints()
    this.addUpRefresh()
  },
  methods: {
    goHome () {
      this.$router.push({
        path: goHomePath()
      })
    },
    updateItem (item, reload) {
      Object.assign(item, reload)
    },
    deleteMessage (id) {
      let index = 0
      this.list.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.list.splice(index, 1)
    },
    addUpRefresh () {
      const el = this.$refs.makeComplaints
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, list, page } = this
          if (count > list.length) {
            this.loading = true
            this.page = page + 1
            this.getMakeComplaints()
          }
        }
      })
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = getUser('makeComplaints')
        if (scrollTop) {
          this.$refs.makeComplaints.scrollTop = scrollTop
          remove('makeComplaints')
        }
      })
    },
    goCreate () {
      this.$router.push({
        path: '/exerland/makeComplaintsCreate'
      })
    },
    goDetails () {
      set('makeComplaints', this.$refs.makeComplaints.scrollTop)
    },
    getMakeComplaints () {
      this.loading = true
      const { page, size } = this
      const promise = get({
        url: `/diss/diss?page=${page}&size=${size}&user=${
          getUser('user').id
        }`
      })
      promise.then(res => {
        this.loading = false
        const {
          data: {
            code,
            detail: { count, data }
          }
        } = res
        if (Object.is(code, 200)) {
          this.count = count
          this.list = [...this.list, ...data]
        }
      })
    }
  },
  computed: {
    getTarbarAuth () {
      return this.$store.getters['tarbarAuth/getAuth']
    }
  }
}
</script>
<style lang="scss" scoped>
.makeComplaints {
  background: #fff;
  overflow-y: scroll;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  height:  100vh;
  -webkit-overflow-scrolling: touch;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 72px;
    img {
      width: 100%;
      height: 100%;
    }
    .button {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        box-sizing: border-box;
        width:103px;
        height:32px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 10px 0px rgba(0,0,0,0.38);
        border-radius:16px;
        font-size:17px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(0,0,0,1);
        border: none;
        outline: none;
      }
    }
  }
  .downLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 50px;
    text-align: center;
    background: #fff;
  }
  h3 {
    font-size: 17px;
    font-family: SFProText-Semibold, SFProText;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    text-align: center;
    padding: 13px 4.27vw;
  }
  .content {
    margin-bottom: 1px;
    margin-top: 72px;
  }
  .loading {
    background: #fff;
    display: block;
    width: 100vw;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
</style>
